import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Transfer } from 'components/Page';
import config from './config';

const mapStateToProps = state => ({
  competency: state.api.competency.data,
  inFlight: state.api.competency.inFlight
});

const CompetencyActivities = ({ objectId, permissions }) => {
  // if record is localy managed and the user has permissions
  const canAdmin = permissions.CanAdminCompetencies()
    .hasPermissions();
  const handleAssign = activities => ({
    activities
  });
  return (
    <Transfer
      canAdmin={canAdmin}
      reducer={{
        destination: REDUCER_KEY.assignedCompetencyActivities,
        source: REDUCER_KEY.unAssignedCompetencyActivities
      }}
      objectId={objectId} // the parent object
      config={{
        ...config,
        // Table ToolBar Buttons
        commands: {
          disableAdd: !canAdmin,
          disableRemove: !canAdmin
        },
        // override source table config with current data
        source: {
          ...config.source,
          // record filter for unassigned users
          filters: {
            competency_id__ne: [objectId]
          },
          // Table row config
          rowSelectionConfig: {
            ...config.source.rowSelectionConfig,
            selectItemOnSingleClick: canAdmin,
            highlightRow: canAdmin
          }
        },
        // override destination table config with current data
        destination: {
          ...config.destination,
          // record filter for assigned users
          filters: {
            competency_id: [objectId]
          }
        }
      }}
      onPrepareSourceData={handleAssign}
      permissions={permissions}
    />
  );
};

CompetencyActivities.propTypes = {
  objectId: PropTypes.number,
  permissions: PropTypes.object.isRequired
};

CompetencyActivities.defaultProps = {
  objectId: null
};

export default connect(mapStateToProps, null)(CompetencyActivities);
